import { cn } from '@/helpers/utils/functionality-utils';
import { EllipseLabel } from '@/modules/global-components/ui/wrappers/EllipseLabel';
import { Skeleton } from 'primereact/skeleton';

interface InfoTextProps {
  title: string | React.ReactNode;
  text: string | React.ReactNode;
  containerClassName?: string;
  skeletonClassName?: string;
  titleClassName?: string;
  textClassName?: string;
  showEmptyForFalsy?: boolean;
  textWrap?: boolean;
  loading?: boolean;
  customFontSize?: boolean;
}

export const InfoText = ({
  title,
  text,
  containerClassName,
  titleClassName,
  textClassName,
  showEmptyForFalsy,
  textWrap,
  loading,
  skeletonClassName,
  customFontSize,
}: InfoTextProps) => {
  let _text;
  if (text !== undefined && text !== null && text !== '') {
    if (text === true) {
      _text = 'Yes';
    } else if (text === false) {
      _text = 'No';
    } else {
      _text = text;
    }
  } else {
    _text = 'N/A';
  }

  if (loading) {
    return (
      <Skeleton
        className={cn(
          '!h-20 !w-full !shrink-0',
          containerClassName,
          skeletonClassName,
        )}
      />
    );
  }

  if (showEmptyForFalsy && _text === 'N/A') {
    return null;
  }

  return (
    <div
      className={cn('flex flex-col gap-2 overflow-hidden', containerClassName)}
    >
      {typeof title === 'string' ? (
        <EllipseLabel
          className={cn(
            'shrink-0 text-lg font-bold text-surface-900',
            titleClassName,
          )}
          label={title || '\u200B'}
        />
      ) : (
        <div className="shrink-0 text-lg font-bold text-surface-900">
          {title || '\u200B'}
        </div>
      )}
      <div
        style={{
          fontSize: customFontSize ? undefined : 'min(max(1rem, 4vw), 22px)',
          whiteSpace: textWrap ? 'pre-wrap' : 'nowrap', // 'pre-wrap' to accept "\n" characters
        }}
        title={typeof text === 'string' ? text : ''}
        className={cn(
          'flex w-full min-w-0 items-center gap-2 text-surface-400',
          textClassName,
        )}
      >
        {typeof _text === 'string' ? (
          textWrap ? (
            _text
          ) : (
            <EllipseLabel label={_text} />
          )
        ) : (
          // handle react components
          _text
        )}
      </div>
    </div>
  );
};

export const InfoTextEmpty = (props: InfoTextProps) => {
  return <InfoText {...props} showEmptyForFalsy />;
};
